export const tables = {
    organisations: [{
        name: 'ORGANISATION NAME',
        key: 'organisation_assessment_credit__organisation__organisation_name',
        link: '',
        sort: true,
    },
    {
        name: 'INSTRUMENT',
        key: 'organisation_assessment_credit__instrument__instrument_name',
        link: '',
        sort: true,
    },
    {
        name: 'SOLD',
        key: 'total_sold',
        link: '',
        sort: false,
    },
    {
        name: 'CREDITS IN USE',
        key: 'credit_in_use',
        link: '',
        sort: false,
    }],
    admins: [{
        name: 'FULL NAME',
        key: 'full_name',
        sort: true,
        type: 'text',
        content: '',
        link: '',
    },
    {
        name: 'EMAIL',
        key: 'email',
        sort: true,
        type: 'text',
        content: '',
        link: ''
    },
    {
        name: 'PRIMARY ADMIN',
        key: 'user_access__is_primary_admin',
        sort: false,
        type: 'button',
        content: 'MAKE PRIMARY ADMIN'
    },
    {
        name: 'REMOVE',
        key: 'remove',
        sort: false,
        type: 'deleteIcon',
        content: 'remove',
        childKey: 'user_access__is_primary_admin'
    }],
    credits: [{
        name: 'INSTRUMENT',
        key: 'instrument__instrument_name',
        sort: true,
        type: 'text',
        content: '',
        link: ''

    },
    {
        name: 'UNSOLD',
        key: 'unsold_credits',
        sort: false,
        type: 'text',
        content: '',
        link: ''
    },
    {
        name: 'SOLD (IN USE)',
        key: 'sold__credits_in_use',
        sort: false,
        type: 'text',
        content: '',
        link: ''
    },
    {
        name: 'SELL CREDITS',
        key: 'remove',
        sort: false,
        type: 'icon',
        content: 'add'
    },
    {
        name: 'REVOKE CREDITS',
        key: 'remove',
        sort: false,
        type: 'icon',
        content: 'remove'
    }]
}


// WEBPACK FOOTER //
// ./src/_pages/Admin/Sellers/Details/tableColumns.js